<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				加班申请-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<div @click="StaffFind">
								<el-form-item label="加班人" prop="overtime_staff" style="margin-top: 30px;">
									<el-input style="width:100%" v-model="ruleForm.overtime_staff_name"
										onfocus="this.blur();"></el-input>
								</el-form-item>
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="开始时间" prop="start_date">
								<el-date-picker v-model="ruleForm.start_date" style="width:100%" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="请选择">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="结束时间" prop="end_date">
								<el-date-picker v-model="ruleForm.end_date" style="width:100%" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="请选择">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="加班时长" prop="overtime_duration">
								<el-input v-model="ruleForm.overtime_duration" style="width:100%">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="加班原因" prop="overtime_reason">
								<el-input type="textarea" :rows="4" style="width:100%" placeholder="请输入加班原因"
									v-model="ruleForm.overtime_reason">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item style="text-align: center;" label-width="0">
								<el-button type="goon" @click="AddAuditor()"
									v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
								<el-button type="goon" @click="UpdateAuditor()"
									v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
								<el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>

			</div>

		</div>

		<el-dialog title="选择加班人" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				<organizeStaff ref="organizeStaff" type="checkbox" :accordion="true"
					@commit="saveChange" :staff_ids_prop="object.staff_ids"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="1" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog>

	</div>
</template>

<script>
	import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		components: {
			organizeStaff: organizeStaff,
			SelectAuditor: SelectAuditor,
		},
		props: ["organizeList"],
		data() {
			return {
				//表单数据
				ruleForm: {
					id: '',
					project_id: '',
					overtime_staff: '',
					overtime_staff_name: '',
					start_date: '',
					end_date: '',
					overtime_duration: '',
					overtime_reason: '',
					examineDetailsList: [],
				},

				//暂存数据
				object: {
					staff_ids: [],
					staff_name: "",
					project_id: "",
					project_name: ""
				},

				//表单验证
				rules: {
					overtime_staff: [{
						required: true,
						message: '请选择加班人！',
						trigger: 'blur'
					}],
					start_date: [{
						required: true,
						message: '请选择开始时间！',
						trigger: 'blur'
					}],
					end_date: [{
						required: true,
						message: '请选择结束时间！',
						trigger: 'blur'
					}],
					overtime_reason: [{
						required: true,
						message: '请输入加班原因！',
						trigger: 'blur'
					}],
				},

				//页面相关
				dialogVisible: false,
				dialogAuditorVisible: false
			};
		},
		methods: {
			StaffFind() {
				this.dialogVisible = true;
				this.showtxbm = true;
			},
			//设置确定
			saveChange(e) {
				var overtime_staff = "";
				e.staff_ids.forEach(item => {
					overtime_staff += item + ",";
				})

				this.ruleForm.overtime_staff = overtime_staff;
				this.ruleForm.overtime_staff_name = e.staff_name;
				this.ruleForm.project_id = e.organize_id;
				this.ruleForm.project_name = e.organize_name;
				this.dialogVisible = false;
			},
			//添加
			AddAuditor() {
				debugger
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//添加
			async Add() {
				var url = 'overtime/add';
				var record = {
					project_id: this.ruleForm.project_id,
					overtime_staff: this.ruleForm.overtime_staff,
					start_date: this.ruleForm.start_date,
					end_date: this.ruleForm.end_date,
					overtime_duration: this.ruleForm.overtime_duration,
					overtime_reason: this.ruleForm.overtime_reason,
					examineDetailsList: this.ruleForm.examineDetailsList,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//修改
			UpdateAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Update() {
				var url = 'overtime/modify';
				var record = {
					id: this.ruleForm.id,
					project_id: this.ruleForm.project_id,
					overtime_staff: this.ruleForm.overtime_staff,
					start_date: this.ruleForm.start_date,
					end_date: this.ruleForm.end_date,
					overtime_duration: this.ruleForm.overtime_duration,
					overtime_reason: this.ruleForm.overtime_reason,
					examineDetailsList: this.ruleForm.examineDetailsList,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			Return() {
				this.dialogAuditorVisible = false;
				this.$parent.Return();
			}
		},
		created() {
			this.ruleForm = this.$parent.ruleForm;
		},
		watch: {
			"ruleForm.overtime_staff"(newValue) {
				this.object.staff_ids = [];
				newValue.split(",").forEach(item => {
					if (item != '' && item != null) {
						this.object.staff_ids.push(parseInt(item));
					}
				})
			},
			"ruleForm.overtime_staff_name"(newValue) {
				this.object.staff_name = newValue;
			},
			"ruleForm.project_id"(newValue) {
				this.object.project_id = newValue;
			},
			"ruleForm.project_name"(newValue) {
				this.object.project_name = newValue;
			},
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Jbsq_add.vue?d2314e0a